import { render, staticRenderFns } from "./DropzoneForm.vue?vue&type=template&id=b985b06c"
import script from "./DropzoneForm.vue?vue&type=script&lang=js"
export * from "./DropzoneForm.vue?vue&type=script&lang=js"
import style0 from "./Dropzone.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports